// EAC carousel for eac-image-text section
(function () {
  function initCarousel(root) {
    const slides = Array.from(root.querySelectorAll('.eac-imgtext__slide'));
    const dots = Array.from(root.querySelectorAll('.eac-imgtext__dot'));
    const prev = root.querySelector('.eac-imgtext__nav--prev');
    const next = root.querySelector('.eac-imgtext__nav--next');
    if (slides.length <= 1) return;

    let idx = slides.findIndex(s => s.classList.contains('is-active'));
    if (idx < 0) idx = 0;
    let timer = null;

    function go(to) {
      idx = (to + slides.length) % slides.length;
      slides.forEach((s, i) => s.classList.toggle('is-active', i === idx));
      dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
    }

    function start() {
      if (root.dataset.autoplay !== 'true') return;
      stop();
      const interval = (parseInt(root.dataset.interval, 10) || 5) * 1000;
      timer = setInterval(() => go(idx + 1), interval);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    prev && prev.addEventListener('click', () => { go(idx - 1); start(); });
    next && next.addEventListener('click', () => { go(idx + 1); start(); });
    dots.forEach((d, i) => d.addEventListener('click', () => { go(i); start(); }));
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);

    start();
  }

  function initAll() {
    document.querySelectorAll('[data-eac-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  // Re-init when theme editor reloads section
  document.addEventListener('shopify:section:load', initAll);
})();
